export function getMetricDataForDateRange_Start(dateRange) {
  return dateRange.start.unix();
}
export function getMetricDataForDateRange_End(dateRange) {
  return dateRange.end.unix() + 24 * 60 * 60;
}

export function getMetricDataForDateRange(data, dateRange, metricId) {
  const dateRangeStartUnix = getMetricDataForDateRange_Start(dateRange);
  const dateRangeEndUnix = getMetricDataForDateRange_End(dateRange);

  const metricData = data[metricId].data.filter(
    i => i.dt.unix() >= dateRangeStartUnix && i.dt.unix() <= dateRangeEndUnix,
  );
  const inRangeCount = metricData.length;
  const prev = data[metricId].data.findLast(i => i.dt.unix() < dateRangeStartUnix);
  const next = data[metricId].data.find(i => i.dt.unix() > dateRangeEndUnix);
  if (prev) metricData.splice(0, 0, prev);
  if (next) metricData.push(next);

  return { data: metricData, inRangeCount, hasPrev: !!prev, hasNext: !!next };
}
